import React from 'react'
import styles from './style.module.scss'
import Badge from '@/components/Badge'
import { useNotify } from 'core/controller/notify/notify'
import { useLocale } from 'core/components/Locale'
import { useHCRouter } from '@/components/HCNextLink'
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'

const NotifyItem: React.FC = () => {
  const t = useLocale()
  const router = useHCRouter()
  const responsiveDevice = useResponsiveDevice()

  // const { unReadCountTotal } = useNotify({
  //   navMaps: [],
  // })

  const handleNavigation = () => {
    if (responsiveDevice === 'phone') {
      router.push('/inMail/noticeList')
      return
    }

    router.push('/inMail/noticeNavList')
  }

  return (
    <>
      <div className={styles.notifyItem} onClick={handleNavigation}>
        {/*<Badge count={unReadCountTotal}>*/}
        {/*  <i className={styles.icon}></i>*/}
        {/*</Badge>*/}
        <i className={styles.icon}></i>
        <span className={styles.label}>{t('inMail_006')}</span>
      </div>
    </>
  )
}

export default NotifyItem
